import React, { useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import "./CreateTaskModal.css";
import FieldUpdate from "../../../../components/SVG/FieldUpdate";
import DocumentUpdate from "../../../../components/SVG/DocumentUpdate";
import { useNavigate } from "react-router-dom";


function CreateTaskModal2({ showModal, onBack, onClose, setSelectedMenu }) {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const taskTypes = [
    "Field Update",
    "Document Update",
    "Video Update",
    "Photo Update",
    "Audio Update",
  ];

  return (
    <Modal show={showModal} onHide={onClose} backdrop="static" size="lg" dialogClassName="create-task-modal" className="create-task-modal-2">
      <Modal.Header closeButton>
        <Modal.Title>Create New Task</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          {taskTypes.map((item, idx) => (
            <Col md={6} className="mb-3" key={idx}>
              <div
                className={`task-card ${selected === idx ? "active" : ""}`}
                onClick={() => {
                    setSelected(idx)
                    if(item?.toLowerCase().includes("field")){
                        setSelectedMenu("Field Update")
                        navigate("/task-management/field-update");
                    }
                    else if(item?.toLowerCase().includes("video")){
                        setSelectedMenu("Video Update")
                        navigate("/task-management/video-update");
                    }
                    else if(item?.toLowerCase().includes("photo")){
                        setSelectedMenu("Photo Update")
                        navigate("/task-management/photo-update");
                    }
                    else if(item?.toLowerCase().includes("document")){
                        setSelectedMenu("Document Update")
                        navigate("/task-management/document-update");
                    }
                    else if(item?.toLowerCase().includes("audio")){
                        setSelectedMenu("Audio Update")
                        navigate("/task-management/audio-update");
                    }
                    onClose();
                }}
              >
                <div className="task-text">
                  <h5>{item}</h5>
                  <p>Total Updates: 08</p>
                </div>

                {/* <img
                  src="https://cdn-icons-png.flaticon.com/512/1827/1827951.png"
                  alt="icon"
                  className="task-icon"
                /> */}
                {
                    (item === "Field Update") ?
                    <FieldUpdate size={"25px"} /> :
                    <DocumentUpdate size={"25px"} />
                }
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button 
            variant="outline-secondary" 
            onClick={onBack}
            className="action-btn secondary-task-btn"
        >
          Cancel
        </Button>
        <Button 
            className="next-btn action-btn" 
            // disabled={selected === null}
        >
          Create Task
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


export default CreateTaskModal2;